import { render, staticRenderFns } from "./ConvenientlyPurchase.vue?vue&type=template&id=a6b4989e&scoped=true&"
import script from "./ConvenientlyPurchase.vue?vue&type=script&lang=js&"
export * from "./ConvenientlyPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ConvenientlyPurchase.vue?vue&type=style&index=0&id=a6b4989e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b4989e",
  null
  
)

export default component.exports